import type { SearchData } from '@/events/conversion';

import { BaseTracker } from './BaseTracker';
import type { TrackerFactory } from './TrackerFactory';

export class SearchTracker extends BaseTracker {
  constructor(factory: TrackerFactory) {
    super(factory);
  }

  track(data: SearchData): void {
    if (!this.factory.isManualEnabled('search')) return;
    this.factory.dispatchManual('SEARCH', data);
  }
}
